"use client"

import { useEffect } from "react"

export function IframeResizer() {
  useEffect(() => {
    if (typeof window === "undefined") return
    if (window.parent === window) return

    let lastHeight = 0

    const send = () => {
      const h = Math.max(
        document.documentElement.scrollHeight,
        document.body?.scrollHeight ?? 0
      )
      if (h !== lastHeight) {
        lastHeight = h
        window.parent.postMessage(
          { type: "ha-embed-resize", height: h },
          "*"
        )
      }
    }

    send()
    const ro = new ResizeObserver(send)
    ro.observe(document.documentElement)
    const interval = window.setInterval(send, 750)

    return () => {
      ro.disconnect()
      window.clearInterval(interval)
    }
  }, [])

  return null
}
